var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 6.83944C3.00333 3.92215 5.56279 1.71387 8.63803 1.71387C12.1096 1.71387 14.9239 4.52807 14.9239 7.99958C14.9239 11.4711 12.1096 14.2853 8.63803 14.2853C5.97283 14.2853 3.69504 12.6267 2.78065 10.2853",
    stroke: "#6C757D",
    strokeWidth: 1.71336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61446 5.55368C5.44026 6.67226 4.05344 7.09746 2.45402 6.82928C1.3354 5.65511 0.910188 4.26833 1.17839 2.66895",
    stroke: "#6C757D",
    strokeWidth: 1.71336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo01);
export default __webpack_public_path__ + "static/media/undo-01.90e4e2c93ca89219c6aba328f2f60290.svg";
export { ForwardRef as ReactComponent };